import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import it from "./locales/it.json";

export const SUPPORTED_LANGUAGES = ["it", "en"] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

const STORAGE_KEY = "pm.lang";

/** The language the user picked in the header (null when the UI follows the browser). */
export function chosenLanguage(): Language | null {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "it" || stored === "en") return stored;
  } catch {
    // Storage unavailable (private mode).
  }
  return null;
}

function initialLanguage(): Language {
  return chosenLanguage() ?? (navigator.language.toLowerCase().startsWith("en") ? "en" : "it");
}

const startLanguage = initialLanguage();
// index.html ships lang="it"; screen readers need it to match the language actually shown.
document.documentElement.lang = startLanguage;

/** Keys must exist in both locale files; it.json is the reference. */
void i18n.use(initReactI18next).init({
  resources: { it: { translation: it }, en: { translation: en } },
  lng: startLanguage,
  fallbackLng: "it",
  interpolation: { escapeValue: false }, // React escapes.
});

export function setLanguage(language: Language): void {
  void i18n.changeLanguage(language);
  document.documentElement.lang = language;
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch {
    // Non-critical.
  }
}

export default i18n;
